<template src="./companychecksetting.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";

  export default {
    components: {},
    filters: {},
    data() {
      return {
        FleetSubscription: {},
        CountCustomCheck: 0,
        CountTotalCheck: 0,
        ShowLoader: false,
        Editmode: false,
        Submitted: false,
        CompanyChecks: [],
        CompanyChecksClasses: [],
        Category: 0,
        AddClassId: 0,
        ClassSubmitted: false,
        ClassAdded: false,
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Settings";
      this.GetVehicleClass();
      this.FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
    },

    methods: {
      GetVehicleClass() {
        Axios.post(Endpoints.VehicleChecks.GetCheckClassList, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response?.data?.success) {
            this.CompanyChecksClasses = Response.data.records;
            this.CompanyChecksClasses.forEach((element, index) => {
              if (index == 0 && element.total_checks > 0) {
                this.Category = element.id;
                var catID = element.id;
                this.GetCompanyChecks(catID);
                $(".cat-links").removeClass("active");
                $("#catid" + catID).addClass("active");
              }
            });
          }
        });
      },
      EnableEditMode() {
        this.Editmode = true;
      },
      DisableEditMode() {
        this.Editmode = false;
      },
      GetCompanyChecks(catID) {
        this.ShowLoader = true;
        Axios.post(Endpoints.VehicleChecks.GetCompanyChecks, {
          token: localStorage.getItem("token"),
          vehicle_class_id: catID,
        }).then((Response) => {
          this.ShowLoader = false;
          this.CompanyChecks = Response.data.CompanyChecks;
          this.CompanyChecks[0]["required"] = true;
          this.CountCompanyCustomChecks();
        });
      },
      CountCompanyCustomChecks() {
        this.CountCustomCheck = 0;
        this.CountTotalCheck = 0;
        this.CompanyChecks.forEach((element, index) => {
          if (this.CompanyChecks[index]["description"]) {
            this.CompanyChecks[index]["description"] = this.CompanyChecks[
              index
            ]["description"].replaceAll(/(?:\\[rn])+/g, "");
          }

          if (element.required == 1) {
            this.CompanyChecks[index]["required"] = true;
          } else {
            this.CompanyChecks[index]["required"] = false;
          }

          if (element.photo_required == 1) {
            this.CompanyChecks[index]["photo_required"] = true;
          } else {
            this.CompanyChecks[index]["photo_required"] = false;
          }

          this.CountTotalCheck = this.CountTotalCheck + 1;
          if (element.custom == 1) {
            this.CountCustomCheck = this.CountCustomCheck + 1;
          }
        });
      },
      SaveCompanyChecks() {
        var error = false;
        this.CompanyChecks.forEach((element) => {
          if (element.id == 0) {
            if (element.name == "") {
              error = true;
              this.$swal("Please Enter Check Name", "", "error");
              return true;
            }
            if (element.description == "") {
              error = true;
              this.$swal("Please Enter Check Description", "", "error");
              return true;
            }
          }
        });
        if (!error) {
          this.Submitted = true;
          this.CompanyChecks.vehicle_class_id = this.Category;
          Axios.post(Endpoints.VehicleChecks.SaveCompanyChecks, {
            token: localStorage.getItem("token"),
            CompanyChecks: this.CompanyChecks,
          }).then((Response) => {
            this.Submitted = false;
            this.GetCompanyChecks(this.Category);
            this.$swal("Vehicle Checks Saved Successfully", "", "success").then(
              () => {}
            );
          });
        }
      },
      DeleteCompanyChecks(checkid) {
        this.$swal({
          title: "Are you sure You want to delete this Check List?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#514b71",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$swal({
              title: "Deleting...",
              text: "Please wait...",
              imageUrl: require("@/assets/images/LoadingTwo.gif"),
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.VehicleChecks.DeleteCompanyChecks, {
              token: localStorage.getItem("token"),
              id: checkid,
            }).then((Response) => {
              this.CompanyChecks.forEach((value, index) => {
                if (value.id == checkid) {
                  this.CompanyChecks.splice(index, 1);
                }
              });
              this.CountCompanyCustomChecks();
              this.$swal("Check List Deleted Successfully", "", "success").then(
                () => {}
              );
            });
          }
        });
      },
      AddCustomVehicleCheck() {
        if (
          this.FleetSubscription &&
          this.FleetSubscription.allowed_custom_vehicle_checks >
            this.CountCustomCheck
        ) {
          this.Editmode = true;
          var obj = {
            custom: 1,
            id: 0,
            name: "",
            description: "",
            vehicle_class_id: this.Category,
            position: this.CompanyChecks.length + 1,
            required: 1,
            photo_required: 0,
            status: 1,
          };
          this.CompanyChecks.push(obj);
          this.CountCompanyCustomChecks();
        } else {
          this.$swal(
            "You have reached your subscription's maximum allowed vehicle checks. Please contact us to add more checks",
            "",
            "error"
          );
        }
      },
      GetCmpCheckList(catID) {
        this.Editmode = false;
        this.CompanyChecks = [];
        this.Category = catID;
        $(".cat-links").removeClass("active");
        $("#catid" + catID).addClass("active");
        this.GetCompanyChecks(catID);
      },
      addNewClass() {
        var error = false;
        if (this.AddClassId <= 0) {
          error = true;
          this.$swal("Please select template", "", "error");
          return true;
        }
        if (!error) {
          this.ClassSubmitted = true;
          Axios.post(Endpoints.VehicleChecks.AddNewClass, {
            token: localStorage.getItem("token"),
            AddClassId: this.AddClassId,
          }).then((Response) => {
            this.GetVehicleClass();
            this.AddClassId = 0;
            this.ClassSubmitted = false;
            this.$root.$emit("reloadVehicleClass");
            this.$swal(
              "Vehicle Check Template  Added Successfully",
              "",
              "success"
            ).then(() => {});
          });
        }
      },
      deleteClass(classid) {
        this.$swal({
          title: "Are you sure You want to delete this Template?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#514b71",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$swal({
              title: "Deleting...",
              text: "Please wait...",
              imageUrl: require("@/assets/images/LoadingTwo.gif"),
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.VehicleChecks.DeleteClass, {
              token: localStorage.getItem("token"),
              id: classid,
            }).then((Response) => {
              if (Response?.data?.success) {
                this.GetVehicleClass();
                this.$root.$emit("reloadVehicleClass");
                this.$swal(
                  "Vehicle Check Template Deleted Successfully",
                  "",
                  "success"
                ).then(() => {});
              } else {
                this.$swal(Response.data.records, "", "error").then(() => {});
              }
            });
          }
        });
      },
      usedClassAlert() {
        this.$swal(
          "Cannot Delete Template",
          "(This template has been used in vehicle check)",
          "error"
        );
        return true;
      },
    },
  };
</script>

<style scoped>
  .activeAdd {
    text-align: center;
    background: linear-gradient(139deg, #F6339A 16.11%, #FF8904 100.09%) !important;
    color: #fff;
    overflow: hidden;
  }
  .text-primary {
    color: linear-gradient(139deg, #F6339A 16.11%, #FF8904 100.09%) !important;
  }
  .deleteClass {
    font-size: 16px;
    margin: 2px 0 0 20px;
  }

</style>
<style >
  .checkbox label::before{
    border:1px solid #6c6b6b !important;
  }
  .checkbox-solid-success input[type=checkbox]:checked + label::before{
        border-color: #51bb25  !important;
  }
</style>
